'use client';

import React, { useRef, useEffect } from 'react';

// ฟังก์ชันสำหรับสร้างรายการเดือนย้อนหลัง 6 เดือน
const getLastSixMonths = () => {
  const months = [
    'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
    'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
  ];
  const today = new Date();
  const lastSixMonths = [];

  for (let i = 0; i < 6; i++) {
    const d = new Date(today.getFullYear(), today.getMonth() - i, 1);

    const last_day = new Date(); last_day.setFullYear(d.getFullYear(), d.getMonth() + 1, 0); 
    lastSixMonths.unshift({
      start_date: `${d.getFullYear()}-${d.getMonth()}-1`,
      end_date: `${d.getFullYear()}-${d.getMonth()}-${last_day.getDate()}`,
      month: months[d.getMonth()],
      year: d.getFullYear(),
    });
  }
  return lastSixMonths;
};

const monthsList = getLastSixMonths();

const MonthsPicker = ({ onMonthSelect }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (containerRef.current) {
      const lastIndex = monthsList.length - 1;
      const itemHeight = 40; // กำหนดความสูงของแต่ละรายการ
      containerRef.current.scrollTop = lastIndex * itemHeight - containerRef.current.clientHeight / 2 + itemHeight / 2;
    }
  }, []);


  return (
    <div className="month-picker">
      <div className="grid grid-cols-2 gap-2">
          {monthsList.map((month) => (
            <button key={month.month} className="month-button text-white" onClick={() => onMonthSelect(month)}>
              {month.month} {month.year}
            </button>
          ))}
      </div>
    </div>
  );
};

export default MonthsPicker;
